import React from 'react';
import { CornerDownRightIcon } from 'lucide-react';
import { CarriedAdjustment } from '../../types/commission';
import { sumCents } from '../../utils/format';
import { Card } from '../sf/Card';
import { Td, Th } from '../sf/DataTable';
import { ExampleDataBadge } from '../sf/ExampleDataBadge';
import { Money } from '../sf/Money';
import { NewBadge } from '../sf/NewBadge';
import { StatusBadge } from '../sf/StatusBadge';
export function CarriedAdjustmentsCard({
  adjustments
}: {
  adjustments: CarriedAdjustment[];
}) {
  const net = sumCents(adjustments.map(item => item.amount));
  return <Card title={`Adjustments carried in (${adjustments.length})`} icon={CornerDownRightIcon} iconBg="#FE9339" meta="Changes to loans in locked periods post to the next open period — the locked period is never edited" bodyClassName="" actions={<>
          <NewBadge data-id="element-928" data-mp="3l951cxjcewxh" />
          <ExampleDataBadge data-id="element-929" data-mp="3l7k7la4uri0o" />
        </>} data-id="element-927" data-mp="2dvjrez8epak2">
      <p className="border-t border-sf-border px-4 py-2 text-xs text-sf-weak" data-id="element-930" data-mp="1vrnsediaiccn">Today a post-funding loan edit silently rewrites the original month’s fee.</p>
      <div className="overflow-x-auto" data-id="element-931" data-mp="20pflvbyl26iy">
        <table className="w-full border-collapse" data-id="element-932" data-mp="24sc6t9blieq2">
          <thead data-id="element-933" data-mp="24tnal951jmh6">
            <tr data-id="element-934" data-mp="24t53tikr5pv0">
              <Th data-id="element-935" data-mp="24qiyzqp8xogh">Adjustment</Th>
              <Th data-id="element-936" data-mp="29ryj9gjlnqxt">From Period</Th>
              <Th data-id="element-937" data-mp="29qwvcbhhj9yo">Loan</Th>
              <Th data-id="element-938" data-mp="29pc9rbd5f1cy">Reason</Th>
              <Th data-id="element-939" data-mp="1d1fq1xmezpxi">Posted</Th>
              <Th align="right" data-id="element-940" data-mp="1d27hcw8zb1hz">Amount</Th>
            </tr>
          </thead>
          <tbody data-id="element-941" data-mp="1h29i936w3qw7">
            {adjustments.map(item => <tr key={item.id} data-id="element-942" data-mp="1h0oj109mrjs0">
                <Td className="whitespace-nowrap font-mono text-xs" data-id="element-943" data-mp="1m1ca1lxv00m8">{item.id}</Td>
                <Td className="whitespace-nowrap" data-id="element-944" data-mp="1qsklsomnvy2k">
                  <span className="mr-1.5" data-id="element-945" data-mp="1qu5gce8z7h0f">{item.sourcePeriod}</span>
                  <StatusBadge status="Locked" data-id="element-946" data-mp="tdymufjyqjfb" />
                </Td>
                <Td className="whitespace-nowrap" data-id="element-947" data-mp="yc9woqa9ctxj">
                  <span className="font-semibold text-sf-blue" data-id="element-948" data-mp="yayswqgtbm6f">{item.loanNumber}</span>
                  <span className="block text-xs text-sf-weak" data-id="element-949" data-mp="21m5kflhvcguo">{item.borrower}</span>
                </Td>
                <Td className="min-w-[280px] text-sf-text" data-id="element-950" data-mp="1wn1fj71z95a5">{item.reason}</Td>
                <Td className="whitespace-nowrap text-sf-weak" data-id="element-951" data-mp="2ag0p6sf2w59s">{item.postedOn}</Td>
                <Td align="right" className="font-semibold" data-id="element-952" data-mp="26dw3cfuvgcxp">
                  <Money value={item.amount} signed data-id="element-953" data-mp="26ep9pfpx50fb" />
                </Td>
              </tr>)}
            <tr className="bg-[#FAFAF9] font-semibold" data-id="element-954" data-mp="1iol4j3x30sm7">
              <Td colSpan={5} data-id="element-955" data-mp="1dq07teh1gr2i">Net adjustments (same on both bases)</Td>
              <Td align="right" data-id="element-956" data-mp="1rozr06ls8dra">
                <Money value={net} signed data-id="element-957" data-mp="1rq2iogqxik89" />
              </Td>
            </tr>
          </tbody>
        </table>
      </div>
    </Card>;
}